import { render, staticRenderFns } from "./bodyTable.vue?vue&type=template&id=50e9ac2c&scoped=true"
import script from "./bodyTable.vue?vue&type=script&lang=js"
export * from "./bodyTable.vue?vue&type=script&lang=js"
import style0 from "./bodyTable.vue?vue&type=style&index=0&id=50e9ac2c&prod&lang=scss"
import style1 from "./bodyTable.vue?vue&type=style&index=1&id=50e9ac2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e9ac2c",
  null
  
)

export default component.exports